export function getComponentColor(defaultColor, style, light) {
    if (light) {
        return 'rgb(255, 255, 255)';
    }
    else if (style && typeof style === 'object') {
        if (Array.isArray(style)) {
            const textColor = [...style].reverse().find(x => x && typeof x === 'object' && x.color);
            if (textColor) {
                if (textColor.color === 'light') {
                    return 'rgb(255, 255, 255)';
                }
                return textColor.color;
            }
        }
        else if (style.color === 'light') {
            return 'rgb(255, 255, 255)';
        }
        else if (style.color) {
            return style.color;
        }
    }
    return defaultColor;
}
export function getTextColor(style) {
    const styles = flatStyles(style);
    if (styles.color === 'light') {
        return 'rgb(255, 255, 255)';
    }
    return styles.color;
}
function flatStyles(styles) {
    if (!styles) {
        return {};
    }
    if (!Array.isArray(styles)) {
        return styles;
    }
    return styles.reduce((acc, style) => {
        return Object.assign(Object.assign({}, acc), flatStyles(style));
    });
}
